/**
 * Why a Test Controller sees no scoring window (DELIV-20996 follow-up). Every 2026-27 UAT/QA window is flagged
 * QA, and the list hides QA windows until "Show QA?" is on — with nothing on screen saying so. This is the
 * sentence that says so, kept pure so it is tested without the component.
 */
export interface QaHintWindow { is_qa?: unknown; marking_window_id?: unknown }

const isQa = (w: QaHintWindow) => Number(w && w.is_qa) === 1;
const hasScoringWindow = (w: QaHintWindow) => w && w.marking_window_id !== null && w.marking_window_id !== undefined && String(w.marking_window_id).trim() !== '';

/** Windows the QA toggle is hiding right now (already limited to the chosen academic year by the caller). */
export const hiddenQaWindows = <T extends QaHintWindow>(inYear: T[], isShowQa: boolean): T[] =>
  isShowQa ? [] : (inYear || []).filter(isQa);

/** Empty string when nothing is hidden. */
export const qaHiddenHint = (hidden: QaHintWindow[]): string => {
  if (!hidden || !hidden.length) return '';
  const scoring = hidden.filter(hasScoringWindow).length;
  const windows = `${hidden.length} QA administration window${hidden.length === 1 ? ' is' : 's are'} hidden`;
  const withScoring = scoring ? `, ${scoring} with scoring windows` : '';
  return `${windows}${withScoring}. Turn on "Show QA?" to see ${hidden.length === 1 ? 'it' : 'them'}.`;
};
